import React from "react";
import { Col, Row } from "reactstrap";
import ContactEmailInput from "./ContactEmailInput";
import ContactFirstNameInput from "./ContactFirstNameInput";
import ContactLastNameInput from "./ContactLastNameInput";
import { ContactMobileNoInput } from "./ContactMobileNoInput";
import ContactPhoneExtInput from "./ContactPhoneExtInput";
import { ContactPhoneNoInput } from "./ContactPhoneNoInput";
import ContactTitleInput from "./ContactTitleInput";

export interface IContactInputProps {
  contactFirstNameInputID: string;
  contactLastNameInputID: string;
  contactTitleInputID: string;
  contactEmailInputID: string;
  contactPhoneNumberInputID: string;
  contactPhoneExtInputID: string;
  contactMobileNumberInputID: string;
  isContactPhoneNoRequired?: boolean;
}

export default ({
  contactFirstNameInputID,
  contactLastNameInputID,
  contactTitleInputID,
  contactEmailInputID,
  contactPhoneNumberInputID,
  contactPhoneExtInputID,
  contactMobileNumberInputID,
  isContactPhoneNoRequired,
}: IContactInputProps) => {
  return (
    <>
      <Row>
        <Col sm={6}>
          <ContactFirstNameInput inputID={contactFirstNameInputID} />
        </Col>
        <Col sm={6}>
          <ContactLastNameInput inputID={contactLastNameInputID} />
        </Col>
      </Row>

      <ContactTitleInput inputID={contactTitleInputID} />

      <ContactEmailInput inputID={contactEmailInputID} />

      <Row>
        <Col sm={7}>
          <ContactPhoneNoInput
            inputID={contactPhoneNumberInputID}
            isRequired={isContactPhoneNoRequired}
          />
        </Col>
        <Col sm={5}>
          <ContactPhoneExtInput inputID={contactPhoneExtInputID} />
        </Col>
      </Row>

      <ContactMobileNoInput inputID={contactMobileNumberInputID} />
    </>
  );
};
